import React from 'react';
import PropTypes from 'prop-types';

export default class AccountCCEmail extends React.Component {
  static propTypes = {
    email: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    removeEmail: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    const { id, removeEmail } = this.props;
    this.removeEmail = removeEmail.bind(this, id);
  }

  render() {
    const { email, id } = this.props;

    return (
      <p>
        <span role="button" tabIndex={id} className="fa fa-times" onClick={this.removeEmail} />
        &nbsp;{email}
      </p>
    );
  }
}
